import React from 'react'
import "./services.css"

function Mainsectionservices() {
  return (
      <section className="mainsection">
        <div className="mainservices bg1">
          <div className="center_title">
            <h2>Car Repair</h2>
          </div>
        </div>
        <div className="mainservices bg2">
          <div className="center_title">
            <h2>Hotels & Shotlets</h2>
            <h2>Apartment</h2>
          </div>
        </div>
        <div className="mainservices bg3">
          <div className="center_title">
            <h2>Dry cleaning</h2>
          </div>
        </div>
        <div className="mainservices  bg4">
          <div className="center_title">
            <h2>Tailoring</h2>
          </div>
        </div>
        <div className="mainservices  bg5">
          <div className="center_title">
            <h2>Photography</h2>
          </div>
        </div>
        <div className="mainservices  bg6">
          <div className="center_title">
            <h2>Catering</h2>
          </div>
        </div>
      </section>
  );
}

export default Mainsectionservices